import { addPopupAction, LAYER } from '@theme/js/components/common/PopupManager';
import { AgeVerificationPopup } from './AgeVerificationPopup';
import uuid from 'uuid-random';

const ageVerificationId = uuid();

export const showAgeVerificationPopupAction = ({ onClose } = {}) => addPopupAction({
    id: ageVerificationId,
    component: AgeVerificationPopup,
    layer: LAYER.HIGH_PRIORITY, // ~(TotalCasino Changes)~
    onClose,
    isModal: true
});
